import { inputHandler } from "./class.inputhandler";
import { sceneManager } from "./class.scenemanager";
import { ui } from "./class.ui";
import { palette } from "./class.palette";
import gestoreModuli from "./class.gestoremoduli";

class Top {
    constructor(scene, assetsManager, dimensione, coord, parentMesh) {
        this._mesh = null;
        this._meshTask = assetsManager.addMeshTask("top", "", "dist/assets/imports/", "top/top" + dimensione + ".babylon"),
        this._scene = scene;
        this._parentMesh = parentMesh;
        this._currentColor = palette._defaultBaseColor;
        this._currentBase = 0;

        this._meshTask.onSuccess = (task) => {
            let materialeTop = new BABYLON.StandardMaterial("texture1", this._scene);

            const top = task.loadedMeshes[0];
            top.isPickable = true;
            top.visibility = !sceneManager._topVisible ? 0 : 1;
            top.parent = this._parentMesh;
            top.material = materialeTop;
            top.material.diffuseColor = palette.rgbToBabylon(this._currentColor);
            top.material.specularColor = new BABYLON.Color3(.2, .2, .2);
            /*base.material.metallic = 0;
            base.material.roughness = 0.2;*/
            this._mesh = top;
            this._mesh.position = new BABYLON.Vector3(coord[0], coord[1], coord[2]);

            // sceneManager._shadowGenerator.addShadowCaster(base, true);
            // base.receiveShadow = true;

            top.actionManager = new BABYLON.ActionManager(this._scene);

            top.actionManager.registerAction(
                new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickUpTrigger, (m) => {
                    if (inputHandler._isClickValid) {
                        gestoreModuli.updateBodyToCurrentColor();
                    }
                })
            );
            top.actionManager.registerAction(
                new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOverTrigger, (m) => {
                    if (!inputHandler._isMouseDown) {
                        gestoreModuli.highlightBody(true);
                    }
                })
            );
            top.actionManager.registerAction(
                new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOutTrigger, (m) => {
                    gestoreModuli.highlightBody(false);
                })
            );

        }

    }

    setColor(color) {
        this._currentColor = color;
        this._mesh.material.diffuseColor = palette.rgbToBabylon(this._currentColor);
    }

    highlightTop(status, color) {
        if (status) {
            this._mesh.material.diffuseColor = palette.rgbToBabylon(color);
        } else {
            this._mesh.material.diffuseColor = palette.rgbToBabylon(this._currentColor);
        }
    }

    switchMesh(type) {
        for (let i = 0; i < this._meshes.length; i++) {
            this._meshes[i].visibility = i === type;
            this._meshes[i].isPickable = i === type;
        }
        this._currentBase = type;
    }

    toggleVisibility()
    {
        sceneManager._topVisible = !sceneManager._topVisible;
        this._mesh.visibility = sceneManager._topVisible;
    }

    destroy() {
        this._mesh.dispose();
        gestoreModuli._top = null;
    }

    extractData() {
        let json = { "tipo": this._currentBase, "colore": palette.rgbToName(this._currentColor) };

        return json;
    }
}

export default Top;
